export const SHOW_SHAREPOST = 'SHOW_SHAREPOST'
export const HIDE_SHAREPOST = 'HIDE_SHAREPOST'
export const SHOW_SHARETO = 'SHOW_SHARETO'
export const HIDE_SHARETO = 'HIDE_SHARETO'
export const SHOW_OTHERPOST='SHOW_OTHERPOST'
export const FILL_LIST = 'FILL_LIST'
export const EMPTY_LIST = 'EMPTY_LIST'
export const CHANGE_LIST='CHANGE_LIST'

export const showSharepost = () => {
    return {
        type: SHOW_SHAREPOST
}}

export const hideSharepost = () => {
    return {
        type: HIDE_SHAREPOST
}}

export const showShareto = () => {
    return {
        type: SHOW_SHARETO
}}

export const hideShareto = () => {
    return {
        type: HIDE_SHARETO
}}

export const fillList = (list) => {
    return {
        type: FILL_LIST,
        payload: list
}}

export const emptyList = () => {
    return {
        type: EMPTY_LIST
}}



